import type { CourseTreeNode } from "@/types/generated";
import type { WorksheetStoryboard } from "@/types/storyboard";
import { QuizValidationService } from "@/services/QuizValidationService";
import WorksheetInteractiveFlow from "@/components/storyboard/worksheet/WorksheetInteractiveFlow";
import { storyboardTitle } from "@/lib/storyboardTitle";

interface Props {
  data: WorksheetStoryboard;
  contentElement: CourseTreeNode;
}

export const StoryboardWorksheetRenderer = ({
  data,
  contentElement,
}: Props) => {
  return (
    <WorksheetInteractiveFlow
      id={contentElement.id}
      title={storyboardTitle(data.text.title, contentElement.title)}
      data={data.text}
      onValidate={(answer, taskIndex) =>
        QuizValidationService.validateAnswer({
          type: "worksheet",
          userInput: answer,
          contentElementId: contentElement.id,
          entryIndex: taskIndex,
        })
      }
    />
  );
};
